module.exports = __webpack_public_path__ + "static/media/certificate.02f74a52.svg";